// extracted by mini-css-extract-plugin
export default {"coloredDotCell":"ColoredDotCell_coloredDotCell__f9TPi","tooltipContent":"ColoredDotCell_tooltipContent__TozXf"};